import NavigationBar from "../../../navigation_components/NavigationBar";
import RootUserSideBar from "../../../sidebar_components/RootUserSideBar";
import "../../../../styles/workspace_styles/RootUserStyles/HomePage/HomePage.css";
import { useEffect } from "react";

const HomePage = () =>{
    useEffect(() =>{
        document.title = 'Blink IOT | Home';
    },[]);
    return(
        <div className="root-user-home-page">
            <NavigationBar/>
            <div className="root-user-home-page-layout">
                <div>
                    <RootUserSideBar/>
                </div>
                <div className="root-user-home-page-parent-container">
                    <div className="root-user-home-page-container">
                        <p>Root user Home Page coming soon</p>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default HomePage;